import { render, staticRenderFns } from "./LabelObjects.vue?vue&type=template&id=2446cca1&"
import script from "./LabelObjects.vue?vue&type=script&lang=js&"
export * from "./LabelObjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports